import { CreateUserFormValues } from '@client-ui/components/forms/create-user-form/utils/form-utils';
import { createSelector } from '@ngrx/store';
import { selectSignUpState } from '@shared/store/sign-up/sign-up.selectors';

export const selectSignUpUserState = createSelector(selectSignUpState, (state) => state.user);

export const selectSignUpUserData = createSelector(selectSignUpUserState, (userState): CreateUserFormValues | null => userState.entity);

export const selectSignUpUserIsLoading = createSelector(selectSignUpUserState, (userState): boolean => userState.loading);
